import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "markdown",
  "use": "markdown-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\" id=\"markdown\"><path fill-rule=\"evenodd\" d=\"M16 5a3 3 0 0 1 3 3v4a3 3 0 0 1-3 3H4a3 3 0 0 1-3-3V8a3 3 0 0 1 3-3h12ZM4.818 7H3v6h1.818V9.636l1.818 2.273 1.819-2.273V13h1.818V7H8.455L6.636 9.273 4.818 7Zm10.318 0h-1.818v3H11.5l2.727 3 2.728-3h-1.819V7Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol